"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Public$ = exports.Public$outboundSchema = exports.Public$inboundSchema = void 0;
exports.publicToJSON = publicToJSON;
exports.publicFromJSON = publicFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const transportitem_js_1 = require("./transportitem.js");
/** @internal */
exports.Public$inboundSchema = z
    .object({
    air: z.array(transportitem_js_1.TransportItem$inboundSchema),
    bus_coach: z.array(transportitem_js_1.TransportItem$inboundSchema),
    ferry: z.array(transportitem_js_1.TransportItem$inboundSchema),
    rail: z.array(transportitem_js_1.TransportItem$inboundSchema),
    taxi: z.array(transportitem_js_1.TransportItem$inboundSchema),
    tram_metro: z.array(transportitem_js_1.TransportItem$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "bus_coach": "busCoach",
        "tram_metro": "tramMetro",
    });
});
/** @internal */
exports.Public$outboundSchema = z.object({
    air: z.array(transportitem_js_1.TransportItem$outboundSchema),
    busCoach: z.array(transportitem_js_1.TransportItem$outboundSchema),
    ferry: z.array(transportitem_js_1.TransportItem$outboundSchema),
    rail: z.array(transportitem_js_1.TransportItem$outboundSchema),
    taxi: z.array(transportitem_js_1.TransportItem$outboundSchema),
    tramMetro: z.array(transportitem_js_1.TransportItem$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        busCoach: "bus_coach",
        tramMetro: "tram_metro",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Public$;
(function (Public$) {
    /** @deprecated use `Public$inboundSchema` instead. */
    Public$.inboundSchema = exports.Public$inboundSchema;
    /** @deprecated use `Public$outboundSchema` instead. */
    Public$.outboundSchema = exports.Public$outboundSchema;
})(Public$ || (exports.Public$ = Public$ = {}));
function publicToJSON(value) {
    return JSON.stringify(exports.Public$outboundSchema.parse(value));
}
function publicFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Public$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Public' from JSON`);
}
//# sourceMappingURL=public.js.map